import { io, Socket } from 'socket.io-client';

import { ESocket } from '@enums/api.enum';
import { IdentityTypes } from '@enums/auth.enum';

let socket: Socket | null = null;

export const createSocket = (accessToken: string) => {
	if (!socket) {
		socket = io(import.meta.env.VITE_SOCKET_IO_SERVER!, {
			transports: [ESocket.websocket],
			query: { accessToken, userType: IdentityTypes.ClientSecret },
			autoConnect: false,
			withCredentials: true,
		});
	}
	return socket;
};

export const getSocket = (): Socket | null => socket;
